import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import * as io from 'socket.io-client';
import Socket = SocketIOClient.Socket;
import { environment } from 'environments/environment';

@Injectable()
export class BettingSocketService {
  defaultInstance: Socket;
  routeInstances: { [route: string]: Socket } = {};
  details = {
    'connect timeout': 500,
    reconnect: true,
    'reconnection delay': 500,
    'reopen delay': 500,
    'max reconnection attempts': 10,
    transports: ['websocket'],
  };

  temp = {
    server: '_mutual-betting.edgeless.io',
    serverPorts: {
      main: 443,
    },
  };

  constructor() {
    this.connect(
      'wss://',
      environment.mutualBettingServer + ':' + environment.serverPorts.main
    );
  }

  public join(room: string) {
    this.defaultInstance.emit('join-live-updates', [room]);
  }

  public connect(protocol: string, address: string): void {
    const instance = io.connect(
      protocol + address,
      this.details
    );
    this.defaultInstance = instance;
  }

  public removeListener(route: string, method: string): void {
    if (this.routeInstances[route]) {
      this.routeInstances[route].off(method);
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/betting-socket.service.ts